import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('selectCalibrationKindField');

    return {
        CALIBRATION_TYPE: t('calibrationType'),
        CALIBRATION_TYPE_IS_REQUIRED: t('calibrationTypeIsRequired')
    };
};

export default useTranslation;
